import React from 'react';
import { Template } from 'devextreme-react/core/template';

export const RenderTemplateImage = (options) => {
    return (
//        <div className="templateImage" style={{ backgroundImage: `url(${options.value})` }} />
        <div className="templateImageContainer">
            <img className="templateImage"
                src={options.value}
            />
        </div>

    )
}

export const TemplateImage = () => {
    return <Template name="templateImage" render={RenderTemplateImage} />
}

export const RenderTemplateRawText = (options) => {
    return (
        <div className="templateRawTextContainer"
        >
            {options.value}
        </div>
    )
}

export const RenderTemplateClassName = (options) => {
    return (
        <div className={options && options.data && options.data.ClassName ? options.data.ClassName : "" }
        >
            {options.value}
        </div>
    )
}

export const RenderTemplateLink = (options) => {
    let displayName = (options && options.data && options?.data[options?.column?.dataField + 'DisplayName']) || options?.value;
    return (
        <div className="templateLinkContainer">
            <a
                className="templateLink"
                href={options.value}
                target="_blank"
            >
                {displayName}
            </a>
        </div>
    )
}


